import { NgIf, NgFor, NgClass, NgStyle, SlicePipe } from '@angular/common';
import { Component, forwardRef, HostListener, Input, OnInit, Renderer2, Signal, ViewChild, viewChild, ViewEncapsulation } from '@angular/core';
import { MatButton, MatAnchor } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLinkActive, RouterLink, Router } from '@angular/router';
import { Constant } from '../../../../../../../constants/constant';
import { DefaultClassDirective } from '../../../../../../flex-layout/class';
import { CustomFlexLayoutModule } from '../../../../../../flex-layout/custom-flex-layout.module';
import { DefaultLayoutDirective } from '../../../../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../../../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../../../../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../../../../../flex-layout/flex';
import { DefaultShowHideDirective } from '../../../../../../flex-layout/show-hide';
import { DefaultStyleDirective } from '../../../../../../flex-layout/style';
import { CommonService } from '../../../../../../services/common.service';
import { CharacterPipe } from '../../../../../pipes/character.pipe';
import { ButtonCategoryComponent } from '../../../button-category/button-category.component';
import { MatMenu, MatMenuItem, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { NestedChildComponent } from './nested-child/nested-child.component';
import { environment } from '../../../../../../../environments/environment';
import { Menu2Component } from './menu2/menu2.component';
import { ButtonCategory2Component } from '../../../button-category2/button-category2.component';


@Component({
  selector: 'calsoft-Menu',
    imports: [ButtonCategoryComponent,MatIconModule, ButtonCategory2Component,Menu2Component, NgIf, NgFor, MatButton, MatMenuTrigger, MatIcon, MatAnchor, RouterLinkActive, MatIconModule, DefaultShowHideDirective, MatToolbar, DefaultLayoutAlignDirective, CustomFlexLayoutModule, MatMenu, DefaultLayoutDirective, MatMenuItem, RouterLink, NestedChildComponent, DefaultClassDirective, NgClass, NgStyle, DefaultStyleDirective, DefaultLayoutGapDirective, DefaultFlexDirective, SlicePipe, CharacterPipe],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: MenuComponent,
      useExisting: forwardRef(() => MenuComponent),
    },
  ],
})
export class MenuComponent implements OnInit {

  expanded: boolean = false;
   @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @ViewChild('panel') panel!: { menu: MatMenu };
  @Input() categoryArray: any[] = [];
  @Input() data: any;
  @Input() type: any;
  @Input() color: boolean=false;
  @Input() newcolor: boolean=false;

  @Input() displayImageInMenu=0;
  display: boolean = false;
  image:any;
  initImage: boolean=true;

  referer: string | undefined;

  hidePage: boolean = false;
  excludedUrls: string[] = [
    // '/marketing',
    // '/software-product-developments',
    // '/Software-Architecture-Developments',
    // '/mobile-application-developments',
    // '/saas-application-developments'
    '/course/'
  ];

  constructor(
    public router: Router,
    private commonService: CommonService,
    private ren: Renderer2

    ) {
  }


  public serverPath = environment.commonImageApi + 'category/image/150x150/';
  
  ngOnInit() {
    this.menuItems = this.categoryArray.slice(0, 4);
    this.referer=Constant.REFERER;
    
    if (window.innerWidth < 1281) {
      this.display = false;
    }else{
      this.display=true
    }
   // this.data.categoryMenuType = 6;

   let currentUrl = this.router.url;
 //  this.newcolor = this.excludedUrls.includes(currentUrl);


 if(!this.newcolor){
  if (this.excludedUrls.some(url => currentUrl.includes(url))) {
    this.newcolor = true;
   }else{
    this.newcolor = false;
   }
 }
  

  }
  goToCategory(menu : any) {

    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);

  }


  NavigationNone(){
    
  }

  public onItemSelected(item: any) {
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }


  public redirectTo(subchildState : any) {
    this.router.navigate([subchildState.state], { queryParams: { category: subchildState.queryState } });
  }

  openMegaMenu(){
    let pane = document.getElementsByClassName('cdk-overlay-pane');
    [].forEach.call(pane, function (el : any) {
        if(el.children.length > 0){
          if(el.children[0].classList.contains('mega-menu')){
            el.classList.add('mega-menu-pane');
          }
        }
    });
  }

  closeMyMenu(){
    this.menuTrigger.closeMenu();
   // console.log('close')
  } 
  activeMenu = null;

  menuItems: any[] = [];
  timeout: any;
  openSubMenu(menu : any) {
    clearTimeout(this.timeout); // Clear any pending close action
    this.activeMenu = menu; // Set the hovered menu as the activeMenu
  }
  
  closeSubMenu() {
    this.timeout = setTimeout(() => {
      this.activeMenu = null; // Clear the activeMenu when the mouse leaves
    }, 200); // Delay closing by 200ms to allow users time to move
  }
  

  keepSubMenuOpen() {
    clearTimeout(this.timeout); // Prevent the submenu from closing when hovering over it
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Close submenu if clicked outside
    if (this.activeMenu && !(event.target as HTMLElement).closest('.menu-item, .submenu-container')) {
      this.activeMenu = null;
    }
  }


  open(menu : any){
    menu.openMenu();
    }

    enteredButton = false;
    isMatMenuOpen = false;
    isMatMenu2Open = false;
    prevButtonTrigger : any;
    buttonLeave(trigger : any, button:any) {
      setTimeout(() => {
        if (this.enteredButton && !this.isMatMenuOpen) {
          trigger.closeMenu();
          this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
          this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
        } if (!this.isMatMenuOpen) {
          trigger.closeMenu();
          this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
          this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
        } else {
          this.enteredButton = false;
        }
      }, 100)
    }

    buttonEnter(trigger:any) {
      setTimeout(() => {
        if(this.prevButtonTrigger && this.prevButtonTrigger != trigger){
          this.prevButtonTrigger.closeMenu();
          this.prevButtonTrigger = trigger;
          this.isMatMenuOpen = false;
          this.isMatMenu2Open = false;
          trigger.openMenu();
          this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-focused');
          this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-program-focused');
        }
        else if (!this.isMatMenuOpen) {
          this.enteredButton = true;
          this.prevButtonTrigger = trigger
          trigger.openMenu();
          this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-focused');
          this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-program-focused');
        }
        else {
          this.enteredButton = true;
          this.prevButtonTrigger = trigger
        }
      })
    }
    timedOutCloser : any;
    mouseEnter(trigger : any) {
      if (this.timedOutCloser) {
        clearTimeout(this.timedOutCloser);
      }
      trigger.openMenu();
    }
  
    mouseLeave(trigger : any) {
      this.timedOutCloser = setTimeout(() => {
        trigger.closeMenu();
      }, 50);
    }
    
    activeTab: string | "" | undefined;

    featuredBrands = [
      { name: 'Fur Pro', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Furpro.png' },
      { name: 'Zigly', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/ZL-logo.png' },
      { name: 'Kong', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Kong.png' },
      { name: 'Fur Pro', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Furpro.png' },
      { name: 'Zigly', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/ZL-logo.png' },
      { name: 'Kong', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Kong.png' },

      
      // Add more featured brands
    ];
  
    otherBrands = [
      { name: 'Brand A', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Kong.png' },
      { name: 'Brand B', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/ZL-logo.png' },
      { name: 'Brand C', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Furpro.png' },
      { name: 'Brand A', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Kong.png' },
      { name: 'Brand B', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/ZL-logo.png' },
      { name: 'Brand C', logo: 'https://www.zigly.com/media/amasty/shopby/option_images/slider/Furpro.png' },
    ];

    setActiveTab(index: any) {
      this.initImage=false;
      this.defaultIndex = index;
      this.initImage=true;
    }

    defaultIndex:any=0;
  
    setActiveTabs(categoryName: string) {
      this.activeTab = categoryName;
    }
  
    onMouse_Over(menu : any){

      if(menu.subcategories.length>0){
        this.activeTab = menu.subcategories[0].categoryName;
      }
      else{

      }
    }

}
